// extracted by mini-css-extract-plugin
export default {"Navbar":"Navbar_Navbar__MnQdM","logo":"Navbar_logo__MK0b0","num":"Navbar_num__H31XO","crt":"Navbar_crt__1G3bC"};